import React from "react";

import { BodyText } from '../../styles/global'
import { TestimonialWrapper, TestimonialGrid, TestimonialCard, TopSection, BottomSection, ImageWrap, TestimonialTitle } from './Testimonial.style'

const Testimonial = () =>{
 
  return (
    <>
        <TestimonialWrapper>
            
            <h1>Testimonials</h1>
            <TestimonialGrid>
                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                            I feel so blessed
                        </TestimonialTitle>
                        <span>
                           
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                             Tada!!! I’m now a proud equity shareholder of a 
                             reputable company thanks to Bonpellz ultimate goal, 
                             I get to receive my lump sum/dividends on a monthly basis
                              and even without a job, I am financially independent.
                        </BodyText>
                    </BottomSection>
                </TestimonialCard>
                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                                 This is Super Amazing!!
                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                            
                            Academic achievement isn’t just what excites or worth 
                            celebrating for me but having funds awaiting my withdrawal, 
                            funds made readily and easily available by my amazing parents
                             with the bonpellz enabler!
                        </BodyText>
                    </BottomSection>
                </TestimonialCard>
                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26 2.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                                It's fantastic!!!
                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                                With the G.S.A Savings plan, 
                                promises were kept by my uncles and aunties that promised to fund my education 
                                after the demise of my loving dad Now I am a graduate.
                        </BodyText>
                    </BottomSection>
                </TestimonialCard>
                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                            It's Magical
                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                             I was able to land my dream car today courtesy of my special 
                             legends savings plan activated by my brother while I benefitted 
                             off my uncle, received funds transfer from my pals and keep up 
                             with the rest of the Savings, it took me just some few months 
                             what I could have struggled to achieve in years 

                        </BodyText>
                    </BottomSection>
                </TestimonialCard>

                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                                It's so cool
                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                                Stress taken off as I sit back, relax and watch members monthly
                                contribution of our credit co-operative society roll in all 
                                thanks to the G.S.A plus Savings sub plan, No more hassles 


                        </BodyText>
                    </BottomSection>
                </TestimonialCard>

                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                                It's so exciting!

                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                                Yaay! With Bonpellz my dad's trust in me to save has increased 
                                tremendously as he activated my special champions saving plan, 
                                fund an extra month knowing fully well that it can't be withdrawn
                                before the due date and now I can keep up with savings within 
                                few months and easily hit my target goal of an apple laptop
                        </BodyText>
                    </BottomSection>
                </TestimonialCard>

                <TestimonialCard>
                    <TopSection>
                        <ImageWrap>
                            <img src="img/Ellipse 26.svg" alt="" />
                        </ImageWrap>
                        <TestimonialTitle>
                                Bonpellz is the real deal
                        </TestimonialTitle>
                        <span>
                        </span>
                    </TopSection>
                    <BottomSection>
                        <BodyText>
                                Wow!!! I never knew I could cultivate a saving discipline 
                                until I became a Special Saver!  
                        </BodyText>
                    </BottomSection>
                </TestimonialCard> 



            </TestimonialGrid>
        </TestimonialWrapper>
    </>
    
  )
}

export default  Testimonial
